import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../exceptions.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HashMapKeysDefault$iterator$1Class;
function HashMapKeysDefault$iterator$1() {
  if (HashMapKeysDefault$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.$entryIterator_1 = $entryIterator;
      }
      hasNext_bitz1p_k$() {
        return this.$entryIterator_1.hasNext_bitz1p_k$();
      }
      next_20eer_k$() {
        return this.$entryIterator_1.next_20eer_k$().get_key_18j28a_k$();
      }
      remove_ldkf9o_k$() {
        return this.$entryIterator_1.remove_ldkf9o_k$();
      }
    }
    initMetadataForClass($);
    HashMapKeysDefault$iterator$1Class = $;
  }
  return HashMapKeysDefault$iterator$1Class;
}
var HashMapKeysDefaultClass;
function HashMapKeysDefault() {
  if (HashMapKeysDefaultClass === VOID) {
    class $ extends AbstractMutableSet() {
      constructor(backingMap) {
        return new.target.new_kotlin_collections_HashMapKeysDefault_bct206_k$(backingMap);
      }
      static new_kotlin_collections_HashMapKeysDefault_bct206_k$(backingMap) {
        var $this = this.new_kotlin_collections_AbstractMutableSet_hvoaax_k$();
        $this.backingMap_1 = backingMap;
        return $this;
      }
      add_b330zt_k$(element) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_chzcdl_k$('Add is not supported on keys');
      }
      add_utx5q5_k$(element) {
        return this.add_b330zt_k$(element);
      }
      clear_j9egeb_k$() {
        return this.backingMap_1.clear_j9egeb_k$();
      }
      contains_vbgn2f_k$(element) {
        return this.backingMap_1.containsKey_aw81wo_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!true)
          return false;
        return this.contains_vbgn2f_k$(element);
      }
      iterator_jk1svi_k$() {
        var entryIterator = this.backingMap_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        return new (HashMapKeysDefault$iterator$1())(entryIterator);
      }
      get_size_woubt6_k$() {
        return this.backingMap_1.get_size_woubt6_k$();
      }
      checkIsMutable_jn1ih0_k$() {
        return this.backingMap_1.checkIsMutable_jn1ih0_k$();
      }
    }
    initMetadataForClass($, 'HashMapKeysDefault');
    HashMapKeysDefaultClass = $;
  }
  return HashMapKeysDefaultClass;
}
var HashMapValuesDefault$iterator$1Class;
function HashMapValuesDefault$iterator$1() {
  if (HashMapValuesDefault$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.$entryIterator_1 = $entryIterator;
      }
      hasNext_bitz1p_k$() {
        return this.$entryIterator_1.hasNext_bitz1p_k$();
      }
      next_20eer_k$() {
        return this.$entryIterator_1.next_20eer_k$().get_value_j01efc_k$();
      }
      remove_ldkf9o_k$() {
        return this.$entryIterator_1.remove_ldkf9o_k$();
      }
    }
    initMetadataForClass($);
    HashMapValuesDefault$iterator$1Class = $;
  }
  return HashMapValuesDefault$iterator$1Class;
}
var HashMapValuesDefaultClass;
function HashMapValuesDefault() {
  if (HashMapValuesDefaultClass === VOID) {
    class $ extends AbstractMutableCollection() {
      constructor(backingMap) {
        return new.target.new_kotlin_collections_HashMapValuesDefault_3yszgo_k$(backingMap);
      }
      static new_kotlin_collections_HashMapValuesDefault_3yszgo_k$(backingMap) {
        var $this = this.new_kotlin_collections_AbstractMutableCollection_8hg8bd_k$();
        $this.backingMap_1 = backingMap;
        return $this;
      }
      add_sqnzo4_k$(element) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_chzcdl_k$('Add is not supported on values');
      }
      add_utx5q5_k$(element) {
        return this.add_sqnzo4_k$(element);
      }
      contains_m22g8e_k$(element) {
        return this.backingMap_1.containsValue_yf2ykl_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!true)
          return false;
        return this.contains_m22g8e_k$(element);
      }
      iterator_jk1svi_k$() {
        var entryIterator = this.backingMap_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        return new (HashMapValuesDefault$iterator$1())(entryIterator);
      }
      get_size_woubt6_k$() {
        return this.backingMap_1.get_size_woubt6_k$();
      }
      checkIsMutable_jn1ih0_k$() {
        return this.backingMap_1.checkIsMutable_jn1ih0_k$();
      }
    }
    initMetadataForClass($, 'HashMapValuesDefault');
    HashMapValuesDefaultClass = $;
  }
  return HashMapValuesDefaultClass;
}
//region block: exports
export {
  HashMapKeysDefault as HashMapKeysDefaultd8xopyn6vbgh,
  HashMapValuesDefault as HashMapValuesDefault3j1xghpfb6bpq,
};
//endregion

//# sourceMappingURL=HashMapEntryDefault.mjs.map
